import type { TermDetail } from "@termclear/contracts";
import { Sheet } from "./Sheet";

export function VersionsSheet({ term, onClose }: { term: TermDetail; onClose: () => void }) {
  return (
    <Sheet
      title="版本记录"
      description={`${term.name} · 当前 v${term.currentRevision.version}`}
      onClose={onClose}
      className="versions-sheet"
    >
      <div className="sheet-body versions-body">
        <ol className="version-list">
          {term.revisions.map((revision) => (
            <li key={revision.id}>
              <div><strong>v{revision.version}</strong><time>{formatTime(revision.createdAt)}</time></div>
              <p><span>{sourceLabel(revision.source)}</span>{revision.changeSummary}</p>
              {revision.affectedBlockIds.length > 0 ? (
                <p className="version-scope"><span>影响块</span>{revision.affectedBlockIds.join("、")}</p>
              ) : null}
              {revision.questionPoints.length > 0 ? (
                <section className="version-clarifications" aria-label={`v${revision.version} 保留的疑问与回答`}>
                  {revision.questionPoints.map((point) => (
                    <article className="question-point" key={point.id}>
                      <small>{point.targetBlockId}</small>
                      <blockquote>“{point.question}”</blockquote>
                      <p>{point.answer}</p>
                    </article>
                  ))}
                </section>
              ) : null}
            </li>
          ))}
        </ol>
        <section className="marker-activity">
          <h3>简单标记</h3>
          {term.markers.length ? term.markers.map((marker) => (
            <article className="marker-item" key={marker.id}>
              <p className="marker-meta">{marker.blockId} · 基线 {shortId(marker.baselineRevisionId)} · {formatTime(marker.createdAt)}</p>
              <blockquote>{marker.blockSnapshot}</blockquote>
              <p>{marker.note}</p>
            </article>
          )) : <p className="muted">这个术语还没有简单标记。</p>}
        </section>
      </div>
    </Sheet>
  );
}

function sourceLabel(source: TermDetail["currentRevision"]["source"]): string {
  if (source === "website-ai") return "网站 AI";
  if (source === "kit") return "Kit";
  return "导入";
}

function shortId(value: string): string {
  return value.slice(0, 8);
}

function formatTime(value: string): string {
  return new Intl.DateTimeFormat("zh-CN", { dateStyle: "medium", timeStyle: "short" }).format(new Date(value));
}
